import axios from "axios";


export async function exportEntities(namespace?: string){
    try {
        const reqUrl = `https://api.srv-metricslayer.hardware-inno.gcpprodau.tbm.sh/entities${namespace ? `/${namespace}` : ""}` 
        const response = await axios.get(reqUrl);
        const { fieldnames, payload } = response.data;
        
        if (!fieldnames || !payload || !Array.isArray(payload)) {
          throw new Error("Invalid data format received from API");
        }
        
        // Create CSV header row
        let csvContent = fieldnames.join(",") + "\n";
        payload.forEach(item => {
          const rowValues = fieldnames.map(field => {
            let value = item[field];
            
            // Convert Unix timestamp (in seconds) to human-readable format with timezone
            if (field === "last_seen" && value !== undefined && value !== "0") {
              
              // Convert seconds to milliseconds and create a date object
              const date = new Date(value * 1000);
              // Format the date with timezone information
              value = date.toLocaleString('en-US', { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit',
                hour: '2-digit', 
                minute: '2-digit', 
                second: '2-digit',
                timeZoneName: 'short'
              });
            }
            
            return typeof value === "string" ? 
              `"${value.replace(/"/g, '""')}"` : 
              String(value !== undefined ? value : "");
          });
          csvContent += rowValues.join(",") + "\n";
        });
        
        // Create a Blob with the CSV data
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        
        // Trigger download
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "entities_export.csv");
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);
      } catch (error) {
        alert("Failed to export entities: " + (error.response?.data?.message || error.message));
      }
}